import { useState } from "react";
import { FaAddressBook, FaLinkedin, FaVoicemail } from "react-icons/fa";

export const NavigationDots = ({ active }) => {
  const [menu] = useState(["home", "about", "work", "skills", "contact"]);

  return (
    <div className="app__navigation">
      {menu.map((item, index) => (
        // eslint-disable-next-line
        <a
          key={index}
          href={`#${item}`}
          className="app__navigation-dot"
          style={active === item ? { backgroundColor: "#313BAC" } : {}}
        />
      ))}
    </div>
  );
};

export const SocialMedia = () => {
  return (
    <div className="app__social">
      <div>
        <a
          href="https://www.linkedin.com/in/emanuel-mamani-310"
          without
          rel="noreferrer"
          target="_blank"
        >
          <FaLinkedin />
        </a>
      </div>
      <div>
        <a href="mailto:emadesarrollo@gmail.com">
          <FaVoicemail />
        </a>
      </div>
      <div>
        <a
          href="https://drive.google.com/file/d/1RbaFfIX2YkzpJDG7nQPI2hzy59p49i15/view?usp=sharing"
          without
          rel="noreferrer"
          target="_blank"
        >
          <FaAddressBook />
        </a>
      </div>
    </div>
  );
};
